__turbopack_context__.v({
  "loadMoreButton": "searchResultList-module-scss-module__sinVTa__loadMoreButton",
  "searchResultList": "searchResultList-module-scss-module__sinVTa__searchResultList",
});
